module.exports = __webpack_public_path__ + "static/media/drop-arrow-black.3d642c21.svg";